import { combineReducers } from 'redux';
import myPrivilegesReducer from './myPrivilegesReducer';
import healthKeeperReducer from './healthKeeperReducer';

export default combineReducers({
  myPrivileges: myPrivilegesReducer,
  healthKeeper: healthKeeperReducer,
});
